import { domainsInfoInitialState } from '.';
import { DomainsInfo } from 'src/types';
import { OneFormActionTypes, RESET_STATE } from './types';
import { DomainsActionTypes, ADD_DOMAIN } from './domains-types';

export function domainsReducer(state: DomainsInfo = null, action: OneFormActionTypes | DomainsActionTypes): any {
	switch (action.type) {
		case RESET_STATE:
			return domainsInfoInitialState;
		case ADD_DOMAIN:
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
}
